import { render, staticRenderFns } from "./NumberToggle.vue?vue&type=template&id=07a52ebc&scoped=true"
import script from "./NumberToggle.vue?vue&type=script&lang=js"
export * from "./NumberToggle.vue?vue&type=script&lang=js"
import style0 from "./NumberToggle.vue?vue&type=style&index=0&id=07a52ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a52ebc",
  null
  
)

export default component.exports